import styled, {  keyframes, css } from 'styled-components'
import { BodyMedium, BodyDefault, VerySmall } from "../typography/styled";
type ActiveProp = {
  active?:boolean,
  type?:string,
  isDark?:boolean
}

function styleMyEl(type:any) {
  switch (type) {
    case 'info':
    case 'information':
      return css`
        background-color: ${({theme}) => theme.isDark ? theme.palette[200] : theme.primary[40]};
      `;
    case 'error':
      return css`
        background-color: ${({theme}) => theme.isDark ? theme.palette[200] : theme.errors[100]};
      `;
    case 'warning':
      return css`
        background-color: ${({theme}) => theme.isDark ? theme.palette[200] : 'rgba(255, 209, 47, 0.1)'};
      `;
    default:
      return css`
        background-color: ${({theme}) => theme.isDark ? theme.palette[200] : theme.primary[40]};
      `;
  }
}

export const Container = styled.div<ActiveProp>`
  width: 400px;
  display: flex;
  box-sizing: border-box;
  justify-content: space-between;
  right:20px;
  transform:${({active}) => active ? '' : 'translate(420px)' };
  opacity:${({active}) => active ? '1' : '0'};
  transition-property: transform, opacity;
  transition-duration: 0.3s;
  transition-timing-function: ease-out;
  align-items: flex-start;
  padding: 14px;
  border: ${({theme}) => `1px solid ${theme.palette[20]}`};
  border-radius: ${({theme}) => theme.radius.card};
  z-index: 40;
  margin-top: 10px;
  box-shadow: ${({theme}) => theme.shadows.control};
  background-color: ${({theme}) => theme.palette[10]};
`

export const IconBackground = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'type',
})<ActiveProp>`
  ${({type}) => styleMyEl(type)};
  width:28px;
  height:28px;
  padding: 4px;
  margin-right: 8px;
  border-radius: ${({theme}) => theme.radius.control};
  box-sizing: border-box;

  img {
    display: block;
  }
`
export const Title = styled(BodyMedium)<ActiveProp>`
  color: ${({theme}) => theme.palette[900]};
  text-transform: capitalize;
`

export const TitleWrapper = styled.div`
  /* margin-top: 4px; */
  width: 100%;
  display:flex;
  flex-direction: column;
`

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  flex: 0 0 20px;
  padding: 0;
  border: 0;
  background: transparent;
  color: ${({theme}) => theme.palette[800]};

  svg {
    width: 20px;
    height: 20px;
  }

  path {
    stroke: currentColor;
  }

  &:hover {
    cursor: pointer;
  }

  &:focus-visible {
    border-radius: ${({theme}) => theme.radius.xs};
    outline: none;
    box-shadow: ${({theme}) => theme.isDark ? theme.shadows.focusDark : theme.shadows.focus};
  }
`

export const Content = styled(BodyDefault)<ActiveProp>`
  color: ${({theme}) => theme.palette[650]};
  word-break: break-word;
`

export const ProgressBar = styled.progress.withConfig({
  shouldForwardProp: (prop) => prop !== 'success',
})<AlertPropsCustom>`
  display: block;
  appearance: none;
  border: 0;
  width: 100%;
  height: 4px;
  border-radius: 6px;
  margin-top:6px;
  transition: all 0.5s ease-in-out;
  ::-webkit-progress-bar {
    background-color: ${({theme}) => theme.grey[400]};
    border-radius: 6px;
  }
  ::-webkit-progress-value {
    background-color: ${({theme, success}) =>  success ? theme.success : theme.accent[100]};
    border-radius: 6px;
  }
  ::-moz-progress-bar {
    background-color: ${({theme, success}) =>  success ? theme.success : theme.accent[100]};
    border-radius: 6px;
  }
`

export const ThinText = styled(VerySmall)`
  color:${({theme}) => theme.palette[900]};
`
const slideIn = keyframes`
  from {
    transform: translateX(100%);
  }

  to {
    transform: translateX(0%);
  }
`;

const slideOut = keyframes`
  from {
    transform: translateX(0%);
  }

  to {
    transform: translateX(100%);
  }
`;
type AlertPropsCustom = {
  isDark?:any;
  closing?:any;
  success?:boolean;
}
export const AlertCustom = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'closing',
})<AlertPropsCustom>`
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  justify-content: space-between;
  right:20px;
  align-items: flex-start;
  padding: 14px;
  border: ${({theme}) => `1px solid ${theme.palette[20]}`};
  border-radius: ${({theme}) => theme.radius.card};
  z-index: 40;
  margin-top: 10px;
  box-shadow: ${({theme}) => theme.shadows.control};
  background-color: ${({theme}) => theme.palette[10]};
  animation: ${({ closing }) => closing ? css`${slideOut} 0.3s ease-in-out` : css`${slideIn} 0.3s ease-in-out`};

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const AlertsContainer = styled.div`
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 99;
  display: flex;
  flex-direction: column;
  width: min(400px, calc(100vw - 40px));
  max-width: calc(100vw - 40px);

  @media (max-width: 768px) {
    right: 10px;
    bottom: 10px;
    width: calc(100vw - 20px);
    max-width: calc(100vw - 20px);
  }
`
